import { coverageWidgetSetupSelector } from "./coverageWidgetSetupSelector";
import { RootState } from "../../../../store";

export const coverageWidgetSetupTrendTypeSelector = (state: RootState) => {
  return coverageWidgetSetupSelector(state)?.trendType ?? "month_over_month";
};
